import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";

import { datadogRum } from "@datadog/browser-rum";
import Intercom from "@intercom/messenger-js-sdk";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Toaster } from "@ps-design-system/components/Toast";

import publicConfig from "../../../../public-config.js";
import { getGAExperiments } from "../../../../lib/ga_helpers";
import { StatsigContextProvider } from "../../elements-statsig-provider/statsig-context-provider";
import { initAuth } from "../actions/auth";
import { ErrorBoundary } from "../ErrorBoundary";

import IntlProviderHOC from "./IntlProviderHOC";
import NavContainer from "./NavContainer";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previousLocation: {},
      whichModal: "",
      whichModalCb: () => {},
      statsigSdkKey: publicConfig.statsig_sdk_key || "",
      segmentAnonymousID: "",
      SSOid: "",
      statsigEnvironment: publicConfig.statsig_environment || "",
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillMount() {
    const { dispatch, auth } = this.props;
    let { accessToken } = auth;

    if (!accessToken) {
      if (global.PSSessions) {
        accessToken = global.PSSessions.Cookies("PSAccess");
      } else {
        // PSSessions global not available (e.g. Vite dev build without server injection)
        // Fall back to reading the cookie directly
        const match = document.cookie.match(/(^|;\s*)PSAccess=([^;]*)/);
        accessToken = match ? decodeURIComponent(match[2]) : null;
      }
    }

    dispatch(initAuth(accessToken));
  }

  componentDidMount() {
    this.setState({
      statsigSdkKey: publicConfig.statsig_sdk_key || "",
      segmentAnonymousID: global.PSSessions
        ? PSSessions.Cookies("ajs_anonymous_id")
        : "",
      SSOid: global.PSSessions ? PSSessions.Cookies("PSUser") : "",
      statsigEnvironment: publicConfig.statsig_environment || "",
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.setState({ previousLocation: this.props.location });
    }
  }

  componentDidUpdate(prevProps) {
    const profile = this.props.profile?.data;
    const dataDogUser = datadogRum.getUser();
    if (!isEqual(prevProps.profile?.data, profile)) {
      Intercom({
        app_id: window.intercom_app_id,
        user_id: profile?.SSOid,
        name: profile?.first_name,
        user_hash: profile?.intercom_hmac,
        "Account Type": profile?.is_host ? "Host" : "Guest",
      });

      // we need to update the user id in datadog rum, but only if the user id has changed
      // mainly make sure we don't constantly update the user id in datadog rum
      if (profile?.SSOid && dataDogUser?.id !== profile?.SSOid) {
        datadogRum.setUser({
          id: profile.SSOid,
        });
      }
    }
  }

  toggleModal(whichModal, whichModalCb) {
    this.setState({ whichModal, whichModalCb });
  }

  render() {
    const { children, location, profile } = this.props;
    const { segmentAnonymousID, statsigSdkKey, SSOid, statsigEnvironment } =
      this.state;

    return (
      <IntlProviderHOC {...this.props}>
        <ErrorBoundary>
          <div>
            <StatsigContextProvider
              statsigSdkKey={statsigSdkKey}
              segmentAnonymousID={segmentAnonymousID}
              statsigEnvironment={statsigEnvironment}
              SSOid={SSOid}
              profile={profile}
              featureGateNames={[
                "host_confirm_availability_modal",
                "sync_flow_v2",
                "web_hosting_video_embed_nux",
                "pause_listing",
                "host_disintermediation_banner",
                "promoted_by_host",
                "allow_vendor_edits",
                "vat_validation",
                "date_based_pricing",
                "date_based_pricing_callout"
              ]}
              dynamicConfigNames={["web_2_nux", "host_hub_marketing_banners"]}
            >
              <NavContainer location={location} />
              {React.cloneElement(children, {
                previousLocation: this.state.previousLocation,
                whichModal: this.state.whichModal,
                toggleModal: this.toggleModal,
                whichModalCb: this.state.whichModalCb,
                getGAExperiments,
              })}
            </StatsigContextProvider>
            <Toaster viewportProps={{ style: { paddingTop: 88 } }} />
          </div>
        </ErrorBoundary>
      </IntlProviderHOC>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  location: PropTypes.object,
  auth: PropTypes.object,
  profile: PropTypes.object,
};

function mapStateToProps(state) {
  return { auth: state.auth, profile: state.profile };
}

export default connect(mapStateToProps)(App);
